import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import COLORS from 'tstyles/variables.scss';
import Heading from '../../atoms/Heading';
import Content from '../../atoms/Content';
import FontIcon, { SIZES } from '../../atoms/FontIcon';
import Ellipsis from '../../atoms/Ellipsis';
import styles from './notificationContent.module.scss';
var ICON_TYPES = {
  success: 'icon-tick1',
  error: 'icon-cross',
  warn: 'icon-caution',
  info: 'icon-info'
};
var ICON_COLOR = {
  success: COLORS.tekionGreen,
  error: COLORS.mordantRed,
  warn: COLORS.vibrantYellow,
  info: COLORS.denim
};
var DEFAULT_HEADINGS = {
  success: __('Success'),
  error: __('Error'),
  warn: __('Caution'),
  info: __('Info')
};
var NotificationContent = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(NotificationContent, _React$PureComponent);
  var _super = _createSuper(NotificationContent);
  function NotificationContent() {
    _classCallCheck(this, NotificationContent);
    return _super.apply(this, arguments);
  }
  _createClass(NotificationContent, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        message = _this$props.message,
        type = _this$props.type,
        heading = _this$props.heading,
        renderFooter = _this$props.renderFooter,
        contentClassName = _this$props.contentClassName,
        linesLimitForEllipsis = _this$props.linesLimitForEllipsis,
        headingSize = _this$props.headingSize;
      var notificationHeading = heading || DEFAULT_HEADINGS[type];
      return /*#__PURE__*/React.createElement("div", {
        className: styles.toasterContainer
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.iconContainer
      }, /*#__PURE__*/React.createElement(FontIcon, {
        className: styles.icon,
        color: ICON_COLOR[type],
        size: SIZES.XL
      }, ICON_TYPES[type])), /*#__PURE__*/React.createElement("div", {
        className: cx(styles.contentContainer, 'full-width'),
        id: "automation_selector_toaster"
      }, /*#__PURE__*/React.createElement(Heading, {
        size: headingSize
      }, notificationHeading), /*#__PURE__*/React.createElement(Content, {
        className: "".concat(styles.content, " ").concat(contentClassName),
        id: "toastMessage"
      }, /*#__PURE__*/React.createElement(Ellipsis, {
        lines: linesLimitForEllipsis,
        className: styles.notificationContent
      }, message)), renderFooter && renderFooter()));
    }
  }]);
  return NotificationContent;
}(React.PureComponent);
_defineProperty(NotificationContent, "propTypes", {
  message: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  heading: PropTypes.string,
  renderFooter: PropTypes.func,
  contentClassName: PropTypes.string,
  linesLimitForEllipsis: PropTypes.number,
  headingSize: PropTypes.number
});
_defineProperty(NotificationContent, "defaultProps", {
  renderFooter: null,
  contentClassName: '',
  linesLimitForEllipsis: 11,
  headingSize: 3,
  heading: undefined
});
export default NotificationContent;